import Anagrafiche from "../pages/studio/Anagrafiche";

// Scheda unica del segnalatore: la stessa di Anagrafiche → Segnalatori, aperta in sovrimpressione.
export default function SegnalatoreSchedaDialog({ rec, initialName, onSaved, onCancel }) {
  return <Anagrafiche embed={{ atype: "segnalatori", rec, initialName, onSaved, onClose: onCancel }} />;
}
